<template>
    <div :class="['input-wrapper', 'form-input-password', { 'input-has-full-border': fullBorder, 'input-wrapper-mb-2x': marginBottomDouble, 'is-required': required }]">
        <label v-if="label" :for="name" :class="{ 'float-label-active': isFloatLabelActive, 'is-float-label': !withoutFloatLabel }">{{ label }}<span v-if="required">*</span></label>
        <input
            :id="name"
            :class="{ 'input-error-border': hasError, 'full-border': fullBorder, 'basic-border': !fullBorder }"
            :type="passwordInputType"
            :placeholder="placeholder ? placeholder : label"
            :name="name"
            :required="required"
            v-model="inputValue"
            @focus="activateFloatLabel"
            @blur="deactivateFloatLabel"
        />

        <div class="show-password">
            <input type="checkbox" :id="'show_pw_'+name" />
            <label class="label-static" :for="'show_pw_'+name" @click="showPassword">
                <SvgIcon icon="show-pw" />
            </label>
        </div>

        <form-input-error v-if="hasError" :error="errorList[0]"></form-input-error>
        <form-input-note v-else-if="note" :text="note"></form-input-note>
    </div>
</template>

<script>
    export default {
        props: {
            errors: {
                type: Array,
                required: false,
                default: null
            },

            name: {
                type: String,
                required: true
            },

            label: {
                type: String,
                required: false,
                default: null
            },

            placeholder: {
                type: String,
                required: false,
                default: ''
            },

            required: {
                type: Boolean,
                required: false,
                default: false
            },

            fullBorder: {
                type: Boolean,
                required: false,
                default: false
            },

            note: {
                type: String,
                required: false,
                default: null
            },

            marginBottomDouble: {
                type: Boolean,
                required: false,
                default: false
            },

            withoutFloatLabel: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        data() {
            return {
                passwordInputType: 'password',
                inputValue: '',
                hasError: false,
                errorList: this.errors,
                isFloatLabelActive: false
            }
        },

        watch: {
            inputValue: { 
                immediate: true,
                handler(value) {
                    const regex = new RegExp("(?=.*[a-z])(?=.*[A-Z])^.{10,}$")

                    if (value.length > 0 && !this.note) {
                        this.hasError = false
                    }

                    if(this.note && regex.test(value)) {
                        this.hasError = false
                    } else if (this.note && !regex.test(value)) {
                        this.hasError = true
                        this.errorList = [lang.get("The password must contain at least 10 characters and at least one upper and one lower case letter.")]
                    }
                }
            },

            errors: {
                immediate: true,
                handler(errors) {
                    if (errors === null || errors === undefined || errors.length === 0) {
                        this.hasError = false
                    } else {
                        this.hasError = true
                        this.errorList = errors
                    } 
                }
            }
        },

        methods: {
            showPassword() {
                if (this.passwordInputType === 'password') {
                    this.passwordInputType = 'text'
                } else {
                    this.passwordInputType = 'password'
                }
            },

            activateFloatLabel() {
                this.isFloatLabelActive = true
            },

            deactivateFloatLabel() {
                if(this.inputValue.length === 0) {
                    this.isFloatLabelActive = false
                }
            }
        }
    }
</script>
